import React from 'react'

// Persistent "+ Add chapter" row at the bottom of the ToC (author tools only)
export const AddChapterRow = ({ onAdd }) => (
  <li className="CourseNavMenuItem toc-add-chapter-row" role="none">
    <button
      type="button"
      role="menuitem"
      className="toc-add-chapter-btn"
      onClick={onAdd}
    >
      <span className="nav-item-text">
        <i
          className="fa-light fa-plus fa-fw"
          style={{ marginRight: '8px' }}
          aria-hidden="true"
        />
        Add chapter
      </span>
    </button>
  </li>
)
